/* eslint-disable */
import React, {useState} from 'react';
import {Button, CircularProgress, Theme, Tooltip} from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import {getAllFiles} from "@/utils/files/download";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@mui/styles";
import {toastError, toastInfo} from "@/helpers/toast";

const useStyles = makeStyles((theme?: Theme) => ({
    button: {
        display: 'inline-flex',
        width: '30px',
        height: '30px',
        cursor: 'pointer'
    },
    circularProgress: {
        marginRight: '5px',
        marginTop: '2px',
        marginBottom: '2px'
    },
    component: {
        cursor: "pointer"
    }
}));

// hook
const DownloadFileButton = (props: any): any => {
    // connect redux and array of files
    const {uris, zipName, buttonText, component, tooltipText} = props;

    /*console.log('children', component)*/

    // total files
    const count_files = uris.length;

    // get translate
    const {t} = useTranslation();

    const [download, setDownload] = useState(false);

    const classes = useStyles();

    // check if is mobile
    //const fullScreen = useMediaQuery('(max-width:600px)');

    const getAllFilesClick = async () => {
        if (!download) {
            // add general download url
            const files_uris = uris.map((file_uri: any) => {
                //file_uri.url = url; // pasarle la url explícita para el servicio de descarga 
                file_uri.zip_name = zipName;
                return file_uri;
            });

            //console.log('files_uris', files_uris);

            // set download
            setDownload(true);

            // llamada a helper
            await getAllFiles(
                files_uris,
                zipName,
                () => notifyEnd(), // hack para que se ejecute despues de realizar los promises
                () => notifyEnd(true) // hack para que se ejecute despues de realizar los promises
            );
        }
    }

    const notifyEnd = (error: boolean = false) => {
        // set download
        setDownload(false);

        const options: any = {
            position: 'top-right'
        }

        if (error) {
            toastError(t('common.file_error_downloaded', {count: count_files}), options);
        } else {
            toastInfo(t('common.file_downloaded', {count: count_files}), options);
        }
    }

    const tooltipData: any = {
        title: tooltipText || t('common.download_file', {count: count_files}),
        placement: "bottom"
    }

    if (component) {
        return (
            <>
                <div className={classes.component} onClick={() => getAllFilesClick()}>
                    <Tooltip {...tooltipData}>
                        {component}
                    </Tooltip>
                </div>
            </>
        );
    }

    return (
        <>
            {
                (!buttonText) &&
                <div className={classes.button} onClick={() => getAllFilesClick()}>
                    <Tooltip {...tooltipData}>
                        <>
                            {(!download) && <GetAppIcon className={'icon-download-small-no-margin'}/>}
                            {(download) && <CircularProgress size={24}/>}
                        </>
                    </Tooltip>
                </div>
            }

            {
                (buttonText) &&
                <div>
                    <Button
                        onClick={() => getAllFilesClick()}
                        variant="contained"
                        color="primary"
                    >
                        {(download) ? <CircularProgress size={24} className={classes.circularProgress}/> :
                            <GetAppIcon className={'icon-download-small-no-margin'}/>}
                        {" "}
                        {buttonText}
                    </Button>
                </div>
            }

        </>
    );
}

export default DownloadFileButton;
